import styles from './style.m.less';

/**
 * Takes up as much space as a regular icon would, to be used for alignment.
 */
const IconPlaceholder = () => <span className={styles.placeholder} aria-hidden />;

export default IconPlaceholder;
